<main class="login-page">
  <section class="login-welcome" aria-label="Bienvenido a Diazar Cloud">
    <div class="login-welcome-content">
      <img class="login-welcome-logo" src="assets/brand/diazar-cloud.svg" alt="" />
      <p class="login-welcome-title">Bienvenido a Diazar Cloud</p>
      <p class="login-welcome-copy">Una nueva forma de ver y acceder a DiazarControl.</p>
      <ul class="login-welcome-list">
        <li>Accede a tus empresas con tu cuenta.</li>
        <li>Mantén una experiencia unificada y sencilla.</li>
        <li>Inicia sesión de forma segura.</li>
      </ul>
    </div>
  </section>

  <section class="login-panel" aria-labelledby="login-title">
    <div class="login-content">
      <img class="login-logo" src="assets/brand/diazar-cloud.svg" alt="Diazar Cloud" />
      <h1 id="login-title" class="login-title" tabindex="-1" #heading>{{ title }}</h1>
      <p class="login-description">{{ description }}</p>

      @if (errorMessage) {
        <div class="login-error" id="login-error" role="alert">{{ errorMessage }}</div>
      }

      @switch (step) {
        @case ('recovery') {
          <form class="login-reset-form" novalidate (ngSubmit)="submitRecovery()" [attr.aria-busy]="busy">
            @if (resetSent) {
              <div class="login-reset-confirmation" role="status">
                <svg aria-hidden="true" viewBox="0 0 24 24" class="login-icon"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2"/><path d="m8 12 3 3 5-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                <div>
                  <p>{{ resetConfirmation }}</p>
                  <p class="login-reset-spam">Revisa también la carpeta de correo no deseado.</p>
                </div>
              </div>
            }
            <label class="login-field" for="reset-email">
              <span class="login-label">Correo electrónico</span>
              <span class="login-input-wrap">
                <input id="reset-email" name="resetEmail" class="login-input" type="email" autocomplete="email"
                  autocapitalize="none" spellcheck="false" placeholder="usuario@empresa.com" maxlength="508"
                  [(ngModel)]="resetEmail" [disabled]="busy" (ngModelChange)="clearFeedback(); resetSent = false"
                  [attr.aria-invalid]="isInvalid('reset-email') || null"
                  [attr.aria-describedby]="isInvalid('reset-email') ? 'login-error' : null" />
              </span>
            </label>
            <p class="login-reset-help">
              Este proceso restablece tu contraseña global de Diazar. Si ingresas con Google, Microsoft o Apple,
              puedes seguir usando ese botón; la contraseña de ese proveedor se recupera directamente con él.
            </p>
            <button class="login-primary" type="submit" [disabled]="busy || resetCooldownSeconds > 0"
              [attr.aria-busy]="busy">
              {{ busy ? 'Solicitando correo…' : resetSent ? 'Volver a enviar' : 'Enviar enlace de recuperación' }}
            </button>
            @if (resetCooldownSeconds > 0) {
              <p class="login-reset-help">Podrás solicitar otro correo en {{ resetCooldownSeconds }} segundos.</p>
            }
            <button class="login-other-account" type="button" (click)="closeRecovery()">Volver a iniciar sesión</button>
          </form>
        }

        @case ('company') {
          <form class="login-company-form" novalidate (ngSubmit)="submitCompany()">
            <p class="login-account">
              <svg aria-hidden="true" viewBox="0 0 24 24" class="login-icon"><path d="M20 21a8 8 0 0 0-16 0" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="8" r="4" fill="none" stroke="currentColor" stroke-width="2"/></svg>
              <span>{{ signedInEmail }}</span>
            </p>
            <label class="login-field" for="company">
              <span class="login-label">Empresa</span>
              <span class="login-input-wrap login-input-icon">
                <svg aria-hidden="true" viewBox="0 0 24 24" class="login-icon"><path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2 M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2 M10 6h4 M10 10h4 M10 14h4 M10 18h4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
                <input id="company" name="company" class="login-input" type="text" autocomplete="organization"
                  autocapitalize="none" spellcheck="false" placeholder="Nombre de la empresa" maxlength="100"
                  [(ngModel)]="companyName" [disabled]="busy" (ngModelChange)="clearFeedback()"
                  [attr.aria-invalid]="isInvalid('company') || null"
                  [attr.aria-describedby]="isInvalid('company') ? 'login-error' : null" />
              </span>
            </label>
            @if (lastCompany && companyName.trim().toLowerCase() === lastCompany) {
              <p class="login-company-recent">
                <svg aria-hidden="true" viewBox="0 0 24 24" class="login-icon-sm"><path d="m5 12 5 5L20 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
                Última usada
              </p>
            }
            <button class="login-primary" type="submit" [disabled]="busy" [attr.aria-busy]="busy">
              {{ busy ? 'Entrando…' : 'Continuar' }}
            </button>
            <button class="login-other-account" type="button" [disabled]="busy" (click)="useAnotherAccount()">
              Usar otra cuenta
            </button>
          </form>
        }

        @default {
          <form class="login-form" novalidate (ngSubmit)="submitLogin()">
            <div class="login-providers">
              @for (provider of providers; track provider.id) {
                <button class="login-provider" type="button" [disabled]="credentialsDisabled"
                  [attr.aria-busy]="providerInProgress === provider.id" (click)="submitProvider(provider.id)">
                  @switch (provider.id) {
                    @case ('microsoft.com') {
                      <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path fill="#f25022" d="M1 1h10v10H1z"/><path fill="#7fba00" d="M13 1h10v10H13z"/><path fill="#00a4ef" d="M1 13h10v10H1z"/><path fill="#ffb900" d="M13 13h10v10H13z"/></svg>
                    }
                    @case ('apple.com') {
                      <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path fill="currentColor" d="M17.05 12.54c.03 3.22 2.82 4.29 2.85 4.3-.02.07-.45 1.53-1.47 3.03-.89 1.29-1.81 2.57-3.26 2.6-1.42.03-1.88-.84-3.51-.84-1.62 0-2.13.81-3.48.87-1.4.05-2.46-1.4-3.36-2.69-1.83-2.64-3.22-7.47-1.34-10.73.93-1.62 2.59-2.64 4.39-2.67 1.37-.03 2.67.92 3.51.92.84 0 2.42-1.14 4.07-.98.69.03 2.64.28 3.9 2.12-.1.06-2.33 1.35-2.3 4.07ZM14.37 4.6c.75-.91 1.26-2.17 1.12-3.43-1.08.05-2.4.72-3.18 1.63-.7.8-1.3 2.09-1.14 3.32 1.2.09 2.43-.61 3.2-1.52Z"/></svg>
                    }
                    @default {
                      <svg aria-hidden="true" focusable="false" viewBox="0 0 48 48"><path fill="#4285f4" d="M43.61 24.46c0-1.36-.12-2.66-.35-3.92H24v7.43h11a9.4 9.4 0 0 1-4.08 6.17v5.14h6.61c3.87-3.57 6.08-8.83 6.08-14.82Z"/><path fill="#34a853" d="M24 44c5.51 0 10.13-1.83 13.51-4.97l-6.61-5.14c-1.83 1.23-4.17 1.97-6.9 1.97-5.32 0-9.83-3.59-11.45-8.42H5.72v5.3A20 20 0 0 0 24 44Z"/><path fill="#fbbc05" d="M12.55 27.44a12 12 0 0 1 0-6.88v-5.3H5.72a20 20 0 0 0 0 17.48l6.83-5.3Z"/><path fill="#ea4335" d="M24 12.14c3 0 5.68 1.03 7.8 3.05l5.85-5.85A19.6 19.6 0 0 0 24 4 20 20 0 0 0 5.72 15.26l6.83 5.3C14.17 15.73 18.68 12.14 24 12.14Z"/></svg>
                    }
                  }
                  {{ providerInProgress === provider.id ? 'Abriendo ' + provider.label + '…' : 'Continuar con ' + provider.label }}
                </button>
              }
            </div>
            <div class="login-separator" role="separator">o con tu cuenta</div>

            <label class="login-field" for="email">
              <span class="login-label">Correo electrónico</span>
              <span class="login-input-wrap">
                <input id="email" name="email" class="login-input" type="email" autocomplete="username"
                  autocapitalize="none" spellcheck="false" placeholder="usuario@empresa.com" maxlength="508"
                  [(ngModel)]="email" (ngModelChange)="clearFeedback()"
                  [attr.aria-invalid]="isInvalid('email') || null"
                  [attr.aria-describedby]="isInvalid('email') ? 'login-error' : null" />
              </span>
            </label>

            <div class="login-field">
              <div class="login-password-label">
                <label for="password" class="login-label">Contraseña</label>
                <button class="login-recovery-link" type="button" [disabled]="credentialsDisabled"
                  (click)="openRecovery()">¿Olvidaste tu contraseña?</button>
              </div>
              <div class="login-input-wrap">
                <input id="password" name="password" class="login-input login-password" autocomplete="current-password"
                  maxlength="2048" [type]="showPassword ? 'text' : 'password'"
                  [(ngModel)]="password" (ngModelChange)="clearFeedback()"
                  [attr.aria-invalid]="isInvalid('password') || null"
                  [attr.aria-describedby]="isInvalid('password') ? 'login-error' : null" />
                <button class="login-password-toggle" type="button" aria-controls="password"
                  [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                  [attr.aria-pressed]="showPassword" (click)="showPassword = !showPassword">
                  @if (showPassword) {
                    <svg aria-hidden="true" viewBox="0 0 24 24" class="login-icon-sm"><path d="M10.7 5.1A10.4 10.4 0 0 1 12 5c7 0 10 7 10 7a13.2 13.2 0 0 1-1.7 2.7M6.6 6.6A13.5 13.5 0 0 0 2 12s3 7 10 7a9.7 9.7 0 0 0 5.4-1.6M9.9 9.9a3 3 0 0 0 4.2 4.2M2 2l20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  } @else {
                    <svg aria-hidden="true" viewBox="0 0 24 24" class="login-icon-sm"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7S2 12 2 12Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" stroke-width="2"/></svg>
                  }
                </button>
              </div>
            </div>

            <button class="login-primary" type="submit" [disabled]="credentialsDisabled"
              [attr.aria-busy]="busy && providerInProgress === null">
              {{ busy && providerInProgress === null ? 'Iniciando sesión…' : 'Iniciar sesión' }}
            </button>
          </form>
        }
      }
    </div>
  </section>
</main>
